import type { PrivacyContent } from "./types";

export const privacyEn: PrivacyContent = {
  locale: "en",
  seo: {
    title: "Privacy Policy - Prismark",
    description: "Privacy Policy for Prismark, a lightweight pro camera app for iOS."
  },
  title: "Privacy Policy",
  updated: "Last updated: 2026-09-13",
  intro: "Prismark respects your privacy. This Privacy Policy explains how Prismark handles information when you use the app.",
  sections: [
    {
      title: "1. Information We Collect",
      body: [
        "Prismark does not collect, store, or upload your photos or videos. The app provides camera, video recording, dual-camera recording, and gallery review features, with manual controls and real-time exposure tools."
      ]
    },
    {
      title: "2. Camera, Microphone, and Photo Library Access",
      body: [
        "Prismark may request access to your camera to capture photos and videos. Microphone access is used only when recording videos with audio. Photo Library access is used only to save, view, or review media you create with the app."
      ]
    },
    {
      title: "3. Location Information and Photo Metadata",
      body: [
        "Prismark offers an optional feature to record location information in the metadata of photos you capture. This feature is turned off by default and only activates if you explicitly enable it in the app settings.",
        "When enabled, Prismark may request access to your device's location services to obtain your current geographic coordinates. This location data is embedded directly into the metadata (EXIF) of newly captured photos and is stored locally on your device along with the photos themselves.",
        "Location information is used solely for embedding into your photos. Prismark does not collect, upload, or share your location data with any servers or third parties. You can disable this feature at any time in the app settings; disabling it stops new photos from including location metadata, but does not remove location data from photos you have already taken."
      ]
    },
    {
      title: "4. Photos and Videos",
      body: [
        "Your photos and videos remain on your device unless you choose to share or export them using system features. Prismark does not upload your media to our servers."
      ]
    },
    {
      title: "5. Data Storage",
      body: [
        "Prismark may store app settings or preferences locally on your device to improve your experience. These settings are not used to identify you.",
        "If you import your own LUT files, Prismark keeps a copy of them in its own storage on your device so they can be applied to the viewfinder and to the photos and videos you capture. These files stay on your device, are not uploaded anywhere, and are removed when you delete the LUT inside the app or remove the app.",
        "You can delete locally stored app data by removing the app from your device. If you contact us about privacy or data deletion, we will handle the request based on the information reasonably available to us."
      ]
    },
    {
      title: "6. Children's Privacy",
      body: ["Prismark is not designed to collect personal information from children."]
    },
    {
      title: "7. Changes to This Policy",
      body: ["We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated date."]
    },
    {
      title: "8. Contact",
      body: ["If you have any questions about this Privacy Policy, please contact us at:", "axqora@gmail.com"]
    }
  ],
  termsLink: {
    body: "For terms about using Prismark, please read our Terms of Use.",
    label: "Terms of Use",
    href: "/terms"
  }
};
